import registerBlock from '../registerBlock';

// noinspection JSUnusedGlobalSymbols
export { default as EditableText } from './editable-text';

// noinspection JSUnusedGlobalSymbols
export { default as EditableImg } from './editable-img';

// noinspection JSUnusedGlobalSymbols
export { default as ColorToolbarButton } from './color-toolbar-picker';

// Not exported, because loaded on the fly by webpack if necessary
export {default as FallbackBlock} from "./fallback-block";

//Temporary fallback
// noinspection JSUnusedGlobalSymbols
export { default as EditableDiv } from './editable-text';

// Smart Parallax
export { default as SmartParallax} from './smart-parallax';

// Smart Form
export { default as SmartForm} from './smart-form';

registerBlock("select", () => import(/* webpackChunkName: "Select" */"./smart-form/select"));
registerBlock("checkbox", () => import(/* webpackChunkName: "Checkbox" */"./smart-form/checkbox"));
registerBlock("input", () => import(/* webpackChunkName: "Checkbox" */"./smart-form/input"));
registerBlock("textarea", () => import(/* webpackChunkName: "Textarea" */"./smart-form/textarea"));
